import React, { useState } from 'react';
import { ChevronDown, ShieldCheck, AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { useLeadModal } from './LeadModalContext';
export function FAQAndClose() {
  const {
    openModal
  } = useLeadModal();
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const faqs = [{
    q: '¿Por qué es más seguro que el banco?',
    a: 'Un banco puede quebrar o congelar cuentas. La tierra en Propiedad Privada es tuya por ley constitucional. Mientras haya sol y agua en Yucatán, tu activo seguirá ahí, creciendo.'
  }, {
    q: '¿Qué pasa si el dólar sigue subiendo?',
    a: 'Precisamente por eso vendemos Pitahaya. Es un producto de exportación que se cotiza en mercados globales. Si el dólar sube, el valor de tu cosecha en mercados internacionales también aumenta para protegerte.'
  }, {
    q: '¿Es propiedad privada real?',
    a: 'Sí. Nada de ejidos. Recibes título de propiedad inscrito en el Registro Público. La máxima certeza que ofrece el sistema legal mexicano.'
  }];
  return <div className="w-full" data-id="element-8">
      {/* SECTION 7: FAQ */}
      <section className="py-24 px-6 bg-earth text-bunker" data-id="element-9">
        <div className="max-w-3xl mx-auto" data-id="element-10">
          <div className="text-center mb-16" data-id="element-11">
            <h2 className="font-serif text-4xl font-bold mb-4" data-id="element-12">
              Método Búnker: Preguntas Frecuentes
            </h2>
            <p className="font-sans text-bunker/70" data-id="element-13">
              Resolvemos tus dudas con total transparencia.
            </p>
          </div>

          <div className="space-y-4" data-id="element-14">
            {faqs.map((faq, index) => <div key={index} className="border border-bunker/15 bg-white rounded-2xl overflow-hidden transition-all duration-200 shadow-sm" data-id="element-15">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center font-sans font-bold text-lg hover:bg-gray-50" onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-16">
                  <span className="flex items-center gap-3" data-id="element-17">
                    <span className="text-pitahaya" data-id="element-18">❓</span> {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-19" />
                </button>

                {openFaq === index && <div className="px-6 pb-6 pt-2 text-bunker/80 leading-relaxed border-t border-bunker/10 bg-gray-50" data-id="element-20">
                    <span className="text-forest font-bold mr-2" data-id="element-21">✅</span>{' '}
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 8: GARANTÍA */}
      <section className="py-20 px-6 bg-pitahaya text-white relative overflow-hidden" data-id="element-22">
        <div className="absolute inset-0 opacity-10 mix-blend-overlay" data-id="element-23">
          <img src="https://images.unsplash.com/photo-1589829085413-56de8ae18c73?q=80&w=2940&auto=format&fit=crop" alt="Legal documents" className="w-full h-full object-cover" data-id="element-24" />
        </div>
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-25">
          <ShieldCheck className="w-16 h-16 mx-auto mb-6" data-id="element-26" />
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-8" data-id="element-27">
            La Garantía "Tangible o Nada"
          </h2>
          <p className="font-sans text-xl leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-28">
            Estamos tan seguros de nuestra certeza jurídica que te damos este
            desafío: Si tu abogado encuentra cualquier irregularidad en nuestros
            títulos de propiedad durante los primeros 30 días, te devolvemos tu
            inversión más un{' '}
            <strong className="bg-white text-pitahaya px-2 py-1 mx-1" data-id="element-29">
              5% adicional
            </strong>{' '}
            por las molestias. No vendemos papel, vendemos paz mental.
          </p>
        </div>
      </section>

      {/* SECTION 9: EL CIERRE */}
      <section className="py-24 px-6 bg-bunker text-earth border-t border-white/10" data-id="element-30">
        <div className="max-w-5xl mx-auto" data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-6" data-id="element-33">
              Los Dos Destinos
            </h2>
            <p className="font-sans text-xl text-earth/70" data-id="element-34">
              Tienes dos caminos para este cierre de año:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-35">
            <div className="border border-white/10 p-8 bg-white/5 opacity-70 hover:opacity-100 transition-opacity" data-id="element-36">
              <AlertTriangle className="w-10 h-10 text-gray-400 mb-6" data-id="element-37" />
              <h3 className="font-serif text-2xl font-bold mb-4 text-gray-300" data-id="element-38">
                Camino A: La Inercia
              </h3>
              <p className="font-sans text-earth/70 leading-relaxed" data-id="element-39">
                Seguir confiando en el banco y ver cómo las noticias
                internacionales desmoronan el valor de tus ahorros mes con mes.
                Aceptar la pérdida silenciosa.
              </p>
            </div>

            <div className="border-2 border-pitahaya p-8 bg-pitahaya/5 relative" data-id="element-40">
              <div className="absolute top-0 right-0 bg-pitahaya text-white text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-41">
                Recomendado
              </div>
              <ShieldCheck className="w-10 h-10 text-pitahaya mb-6" data-id="element-42" />
              <h3 className="font-serif text-2xl font-bold mb-4 text-white" data-id="element-43">
                Camino B: El Refugio
              </h3>
              <p className="font-sans text-earth/90 leading-relaxed" data-id="element-44">
                Tomar acción, mover tu capital a un búnker de "Ladrillos Verdes"
                y dormir con la tranquilidad de quien posee un activo real,
                productivo y seguro.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-45">
            <Button className="text-lg md:text-xl px-10 py-6" onClick={openModal} data-id="element-46">
              SÍ, QUIERO BLINDAR MI CAPITAL — AGENDAR ASESORÍA LEGAL
            </Button>
            <p className="mt-6 text-earth/50 font-sans text-sm" data-id="element-47">
              Plazas limitadas a los próximos 12 lotes en Fase 4.
            </p>
          </div>
        </div>
      </section>
    </div>;
}